export default class extends Controller {
  static targets = ["select", "submit", "conditionalField"];

  connect() {
    App.DynamicSelect.init(this.selectTarget);
    App.DynamicSelect.onChange(this.selectTarget, this.enableSubmitButton.bind(this));
  }

  submitWithConditionalFields(event) {
    this.conditionalFieldTargets.forEach(field => field.value = "1");
  }

  enableSubmitButton() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/forms/form-row-controller.js